import React from 'react';

interface ShareForwardIconProps {
  color?: string;
  size?: number;
  className?: string;
}

export const ShareForwardIcon: React.FC<ShareForwardIconProps> = ({
  color = '#FFFFFF',
  size = 20,
  className = ''
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.9 13.7992H11.1C9.62367 13.7987 8.17523 14.2016 6.91131 14.9646C5.64739 15.7276 4.61607 16.8216 3.92883 18.1282C3.90951 17.8857 3.8999 17.6425 3.90003 17.3992C3.90003 12.4285 7.92933 8.39922 12.9 8.39922V3.44922L22.35 11.0992L12.9 18.7492V13.7992ZM11.1 11.9992H14.7V14.9764L19.4889 11.0992L14.7 7.22202V10.1992H12.9C11.8653 10.1981 10.8424 10.4205 9.90158 10.8512C8.96071 11.2819 8.12401 11.9109 7.44873 12.6949C8.61091 12.2343 9.84989 11.9982 11.1 11.9992Z"
        fill={color}
      />
    </svg>
  );
};

